import '../../../assets/login.css';
import useForm from './useForm';
import { useTranslation } from 'react-i18next';
import { auth } from '../../../firebase-init';
import { Link } from 'react-router-dom';
import Input from '../../../components/UI/inputs/Input';
import InputAuth from '../../../components/UI/Input/InputAuth';

const Login = () => {
  const {
    firebaseLogin,
    firebaseProviderLogin,
    getUserPersonalInformation,
    loginInputs,
    setLoginInputs,
    setErrors,
    errors,
    loading,
    setLoading,
    field,
    submitHandler,
    authMethod,
    setAuthMethod,
    bacMatriculeLogin,
    bacMatricule,
    setBacMatricule,
    birthDate,
    setBirthDate,
  } = useForm();
  const { t, i18n } = useTranslation();

  auth.onIdTokenChanged(async function (user) {
    if (user) {
      const userClaims = await user.getIdTokenResult();
      if (userClaims.claims.role && userClaims.claims.role !== 'STUDENT') {
        await auth.signOut();
        setErrors(t('login.errors.user-not-found'));
      } else {
        await user.reload();
        await getUserPersonalInformation(user.uid);
      }
    }
  });

  return (
    <div className="login-container">
      <div className="login-banner" />
      <div className="container">
        <div className="row justify-content-center">
          <div className="col-md-6 hide-on-mobile">
            <h3 className="font-weight-bold text-capitalize" style={{ color: '#243b3d' }}>
              {t('login.steps-to-register.title')}
            </h3>
            <h4 className="font-weight-bold text-capitalize text-dark">{t('login.steps-to-register.title1')}</h4>
            <h5 className="font-weight-bold " style={{ color: 'gray' }}>
              {t('login.steps-to-register.description1')}
            </h5>

            <h4 className="font-weight-bold text-capitalize text-dark">{t('login.steps-to-register.title2')}</h4>
            <h5 className="font-weight-bold " style={{ color: 'gray' }}>
              {t('login.steps-to-register.description2')}
            </h5>

            <h4 className="font-weight-bold text-capitalize text-dark">{t('login.steps-to-register.title3')}</h4>
            <h5 className="font-weight-bold " style={{ color: 'gray' }}>
              {t('login.steps-to-register.description3')}{' '}
              <a 
                href={t('login.steps-to-register.subscriptionUrl')} 
                target="_blank" 
                rel="noopener noreferrer"
                style={{ color: '#4b8b3b', textDecoration: 'underline' }}
              >
                {t('login.steps-to-register.subscriptionLink')}
              </a>
            </h5>
          </div>

          <div className="col-md-6">
            <div className="login-card">
              <h2 className="login-card-title ">{t('login.form.title')}</h2>
              
              <form onSubmit={submitHandler}>
                <div className="form-group login-form-input">
                  <InputAuth type="text" placeholder={t('login.form.placeholderIdentifier')} {...field('identifier')} />
                </div>
                <div className="form-group">
                  <InputAuth type="password" placeholder={t('login.form.placeholderPassword')} {...field('password')} />
                </div>
                <div className="form-group pt-2">
                  <Link to="/password-recovery">{t('login.form.forgot-password')}</Link>
                </div>
                <div className="row justify-content-md-center">
                  <div className="col-12 text-center mt-4">
                    <button
                      className="btn btn-warning  btn-block btn-lg font-weight-bold d-flex justify-content-center "
                      type="submit"
                      disabled={loading}
                      style={{ fontSize: '20px' }}
                    >
                      <span
                        className="spinner-border "
                        role="status"
                        aria-hidden="true"
                        style={{ display: loading === true ? 'block' : 'none' }}
                      ></span>
                      <span className=""> {t('login.form.connect')}</span>
                    </button>
                    <div className="text-start text-danger">
                      <span>{errors}</span>
                    </div>
                    <div className="text-center mt-2">
                      <span>
                        {t('login.form.not-registered')} <Link to="/bac-signup">{t('login.form.register')}</Link>
                      </span>
                    </div>
                  </div>
                </div>
              </form>
            </div>
            <div className="row justify-content-md-center">
              <div className="text-center col-12 d-flex justify-content-center text-uppercase ">
                <h4 className="font-weight-bold ">{t('login.follow-us')}</h4>
              </div>
              <div className="container-social-media-footer">
                <a href="https://www.facebook.com/OPUniversitaire.dz/" target="_blank" rel="noreferrer">
                  <img className="icon-follow-us-auth" src="/assets/images/icons/facebook_dark.png" alt="facebook" />
                </a>
                <a href="https://www.instagram.com/opuniversitaire.dz/" target="_blank" rel="noreferrer">
                  <img className="icon-follow-us-auth" src="/assets/images/icons/instagram_dark.png" alt="instagram" />
                </a>
                <a
                  href="https://www.linkedin.com/in/office-des-publications-universitaires-80a181221/"
                  target="_blank"
                  rel="noreferrer"
                >
                  <img className="icon-follow-us-auth" src="/assets/images/icons/linkedin_dark.png" alt="linkedin" />
                </a>
                <a href="https://www.youtube.com/channel/UCJRAqUw34L8bGmF43J3avog" target="_blank" rel="noreferrer">
                  <img className="icon-follow-us-auth" src="/assets/images/icons/youtube_dark.png" alt="youtube" />
                </a>
              </div>
            </div>
          </div>
        </div>
      </div>
      <footer>
        <div className="d-flex justify-content-center mt-2 d-flex">
          <a href="/privacy" target="_blank" className="px-2">
            Privacy
          </a>
          <a href="/terms-of-service" target="_blank" className="px-2">
            Terms & condition
          </a>
        </div>
      </footer>
    </div>
  );
};

export default Login;
